export enum Status {
  TODO = 'Todo',
  IN_PROGRESS = 'InProgress',
  REVIEW = 'Review',
  DONE = 'Done',
  BLOCKED = 'Blocked'
}

export type StatusType = 'Todo' | 'InProgress' | 'Review' | 'Done' | 'Blocked';

export const isStatusValid = (value: string | null | undefined): value is StatusType => {
  if (!value) return false;
  return Object.values(Status).includes(value as Status);
};

export const getStatusLabel = (status?: StatusType): string => {
  switch (status) {
    case 'Todo':
      return 'A Fazer';
    case 'InProgress':
      return 'Em Progresso';
    case 'Review':
      return 'Em Revisão';
    case 'Done':
      return 'Concluído';
    case 'Blocked':
      return 'Bloqueado';
    default:
      return 'A Fazer';
  }
};

export const getStatusColor = (status?: StatusType): string => {
  switch (status) {
    case 'Todo':
      return '#6c757d'; // Cinza
    case 'InProgress':
      return '#3498db'; // Azul
    case 'Review':
      return '#f39c12'; // Laranja
    case 'Done':
      return '#2ecc71'; // Verde
    case 'Blocked':
      return '#e74c3c'; // Vermelho
    default:
      return '#6c757d'; // Cinza para o padrão
  }
};
